<template>
  <v-app>
    <v-layout>
      <v-main class="main">
        <router-view />
      </v-main>
    </v-layout>
  </v-app>
</template>

<script setup>
import { computed, onBeforeUnmount, reactive, watch } from 'vue'
import useAuthStore from '@/stores/auth'
import useOfferStore from '@/stores/offer'
import useErrorStore from '@/stores/error'
import userService from '@/services/user-service'
import offerService from '@/services/offer-service'
import unistudentsService from '@/services/unistudents-service'

import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

const authStore = useAuthStore()
const offerStore = useOfferStore()
const errorStore = useErrorStore()

const offer = computed(() => offerStore.getAvailableOffer)

const data = reactive({
    timeout: 0
})

function fetchOffer() {
    offerStore.setUpdateOffer(false)
    clearTimeout(data.timeout)
    offerService.getAvailableOffer(route.params.urlCode).then((resp) => {
        offerStore.setOffer(resp.data)
        setupTimeout()
    })
}
function fetchStudentOffer() {
    offerStore.setUpdateOffer(false)
    clearTimeout(data.timeout)
    unistudentsService.getStudentOffer(route.params.urlCode).then((resp) => {
        offerStore.setStudentOffer(resp.data)
        setupTimeout()
    })
}


function setupTimeout() {
    if (!offer.value.coupons) {
        return
    }
    const notExpiredRedeemedCouponsTimes = offer.value.coupons
        .filter((coupon) => coupon.redeemedDate)
        .map((coupon) => new Date(coupon.redeemedDate).getTime())
        .filter((couponTime) => couponTime > Date.now())
    if (notExpiredRedeemedCouponsTimes.length === 0) {
        return
    }
    const minRedemptionDate = Math.min(...notExpiredRedeemedCouponsTimes)
    data.timeout = setTimeout(() => {
        if ( route.name === 'Coupons List') {
            fetchOffer()
        } else if ( route.name === 'Uni Student Coupons List') {
            fetchStudentOffer()
        }
    }, minRedemptionDate - Date.now())
}

watch(
    () => offerStore.updateOffer,
    (newVal) => {
        if (newVal && route.name === 'Coupons List') {
            fetchOffer()
        } else if (newVal && route.name === 'Uni Student Coupons List') {
            fetchStudentOffer()
        }
    }
)

watch(
    () => route.params.urlCode,
    (newVal) => {
        if (route.params.urlCode && route.name === 'Coupons List') {
            userService
                .login({ urlCode: newVal })
                .then((resp) => {
                    authStore.setToken(resp.data.token)
                    if (resp.data.token) {
                        fetchOffer()
                    }
                })
                .catch((err) => {
                    let errorType = 'default'
                    if (err?.response?.data?.message.includes('inactive offer')) {
                        errorType = 'inactiveOffer'
                    }
                    errorStore.setErrorType(errorType)
                    router.push('/error-page')
                })
        } else if (route.params.urlCode && route.name === 'Uni Student Coupons List') {
            fetchStudentOffer()
        }
    }
)


onBeforeUnmount(() => {
    clearTimeout(data.timeout)
    data.timeout = 0
})
</script>
